export default __webpack_public_path__ + "static/media/mendigo.05b95924.png";